export const CELL_WIDTHS = [36, 6, 6, 6, 6, 6, 6, 18];

export const textStyleOverrides = {
  lineHeight: 1.2,
  padding: '2px',
};
